import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import Pets from "./Pets";
import Supplies from "./Supplies";
import styles from "./Home.module.css";

function Home() {
  return (
    <main className={`${styles.home_container}container-fluid`}>
      <Pets id="pets" />
      <Supplies id="suprimentos" />
      <AboutUs id="sobre" />
      <ContactUs id="contato" />
    </main>
  );
}

export default Home;
